var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('div',{staticClass:"checklist header",attrs:{"slot":"header"},slot:"header"},[_c('img',{staticClass:"header-icon",attrs:{"src":require("../image/checklist_new.png")}}),_c('span',{staticClass:"header-title"},[_vm._v("Checklists")])]),_c('ChecklistTable',{attrs:{"patient":_vm.patient,"checklists":_vm.checklists}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }